import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Erro ao renderizar a tela:', error, info.componentStack)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <div className="mx-auto mt-10 max-w-lg rounded bg-surface p-6 text-center shadow-card">
        <span className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-expense/10 text-3xl text-expense">
          <i className="ri-bug-line" aria-hidden />
        </span>
        <h4 className="text-lg font-semibold text-white">Esta tela encontrou um erro</h4>
        <pre className="mt-3 overflow-x-auto whitespace-pre-wrap rounded bg-surface2 p-3 text-left text-xs text-muted">{error.message}</pre>
        <button
          type="button"
          onClick={() => this.setState({ error: null })}
          className="mt-5 inline-flex h-[38px] items-center gap-2 rounded bg-primary/10 px-4 text-13 font-medium text-primary hover:bg-primary hover:text-bg"
        >
          <i className="ri-refresh-line" aria-hidden /> Tentar novamente
        </button>
      </div>
    )
  }
}
